"use strict";

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  box-sizing: ", ";\n  transition: ", ";\n  visibility: ", ";\n\n  /* We need to use this to keep animations working in safari */\n  backface-visibility: hidden;\n  perspective: 1000;\n  transform-style: preserve-3d;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledSystem = require("styled-system");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var StyledForm = _styledComponents.default.form(_templateObject(), _styledSystem.width, _styledSystem.height, _styledSystem.position, _styledSystem.maxWidth, _styledSystem.space, _styledSystem.color, _styledSystem.minHeight, _styledSystem.maxHeight, _styledSystem.zIndex, _styledSystem.display, _styledSystem.opacity, function (props) {
  return props.boxSizing || 'content-box';
}, function (props) {
  return props.transition || 'none';
}, function (props) {
  return props.visibility || 'visible';
});

var _default = StyledForm;
exports.default = _default;